<template>
  <AppDialog
    v-model="isVisible"
    modal
    :closable="true"
    :closeOnEscape="!isManualContactsDialogVisible"
    custom-class="send-template-dialog backdrop-blur-xl! relative px-4"
    width="min(1200px, calc(100vw - 2rem))"
    :breakpoints="{ '640px': 'calc(100vw - 1rem)' }"
  >
    <template #header>
      <div
        class="mt-3 flex w-full flex-col gap-3 pr-8 pb-2 sm:flex-row sm:items-start sm:gap-4 sm:pr-10"
      >
        <div class="flex w-full min-w-0 flex-col gap-3 sm:gap-4">
          <div class="flex flex-col gap-3 xl:flex-row xl:items-start lg:justify-between lg:gap-4">
            <div class="flex min-w-0 flex-col">
              <div class="flex flex-row gap-2">
                <div
                  class="flex items-center w-fit shrink-0 rounded-md bg-[var(--p-primary-color)]/20 p-1.5"
                >
                  <IconMessageBulk width="30" height="30" class="text-[var(--p-primary-color)] dark:text-[var(--p-surface-0)]" />
                </div>
                <div class="flex flex-col">
                  <label
                    class="quicksand break-words text-xl font-semibold leading-tight text-[var(--p-primary-color)] dark:text-[var(--p-surface-0)] sm:text-2xl"
                  >
                    {{
                      $t(
                        isSingleContactFlow
                          ? 'whatsapp.actions.start_conversation'
                          : 'whatsapp.new_bulk_message',
                      )
                    }}
                  </label>
                  <label
                    class="mt-0 text-xs leading-snug text-[var(--p-surface-600)] dark:text-[var(--p-surface-100)]"
                  >
                    {{
                      $t(
                        isSingleContactFlow
                          ? 'whatsapp.actions.start_conversation_description'
                          : 'whatsapp.new_bulk_message_hint',
                      )
                    }}
                  </label>
                </div>
              </div>
            </div>

            <div
              class="flex min-w-0 flex-1 items-center justify-start gap-1 sm:flex-none sm:justify-end gap-5"
            >
              <div class="flex min-w-0 items-center justify-center gap-1 sm:justify-start sm:gap-2">
                <div
                  class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-sm font-semibold text-white shadow-sm"
                  :class="
                    isStepActive(1)
                      ? 'bg-[var(--p-primary-color)]'
                      : 'bg-[var(--p-surface-400)] dark:bg-[var(--p-surface-600)]'
                  "
                >
                  1
                </div>
                <label
                  class="montserrat sr-only !truncate text-sm font-semibold sm:not-sr-only lg:block"
                  :class="
                    isStepActive(1)
                      ? 'text-[var(--p-primary-color)] dark:text-[var(--p-text-color)]'
                      : 'text-[var(--p-surface-500)] dark:text-[var(--p-surface-400)]'
                  "
                >
                  {{ $t('whatsapp.bulk_message_recipients') }}
                </label>
              </div>

              <div class="flex min-w-0 items-center justify-center gap-1 sm:justify-start sm:gap-2">
                <div
                  class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-sm font-semibold text-white shadow-sm"
                  :class="
                    isStepActive(2)
                      ? 'bg-[var(--p-primary-color)]'
                      : 'bg-[var(--p-surface-400)] dark:bg-[var(--p-surface-600)]'
                  "
                >
                  2
                </div>
                <label
                  class="montserrat sr-only !truncate text-sm font-semibold sm:not-sr-only lg:block"
                  :class="
                    isStepActive(2)
                      ? 'text-[var(--p-primary-color)] dark:text-[var(--p-text-color)]'
                      : 'text-[var(--p-surface-500)] dark:text-[var(--p-surface-400)]'
                  "
                >
                  {{ $t('whatsapp.template_selection') }}
                </label>
              </div>

              <!-- ENRUTAMIENTO -->
              <div class="flex min-w-0 items-center justify-center gap-1 sm:justify-start sm:gap-2">
                <div
                  class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-sm font-semibold text-white shadow-sm"
                  :class="
                    isStepActive(3)
                      ? 'bg-[var(--p-primary-color)]'
                      : 'bg-[var(--p-surface-400)] dark:bg-[var(--p-surface-600)]'
                  "
                >
                  3
                </div>
                <label
                  class="montserrat sr-only !truncate text-sm font-semibold sm:not-sr-only lg:block"
                  :class="
                    isStepActive(3)
                      ? 'text-[var(--p-primary-color)] dark:text-[var(--p-text-color)]'
                      : 'text-[var(--p-surface-500)] dark:text-[var(--p-surface-400)]'
                  "
                >
                  {{ $t('whatsapp.routing') }}
                </label>
              </div>

              <div class="flex min-w-0 items-center justify-center gap-1 sm:justify-start sm:gap-2">
                <div
                  class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-sm font-semibold text-white shadow-sm"
                  :class="
                    isStepActive(4)
                      ? 'bg-[var(--p-primary-color)]'
                      : 'bg-[var(--p-surface-400)] dark:bg-[var(--p-surface-600)]'
                  "
                >
                  4
                </div>
                <label
                  class="montserrat sr-only !truncate text-sm font-semibold sm:not-sr-only lg:block"
                  :class="
                    isStepActive(4)
                      ? 'text-[var(--p-primary-color)] dark:text-[var(--p-text-color)]'
                      : 'text-[var(--p-surface-500)] dark:text-[var(--p-surface-400)]'
                  "
                >
                  {{ $t('whatsapp.send_details') }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <div class="min-h-[400px] dark:text-[var(--p-text-color)]">
      <KeepAlive :max="1">
        <SelectCampaignContactsStep
          v-if="currentStep === 1"
          :key="`contacts-${dialogSessionKey}`"
          ref="campaignContactsStepRef"
          :campaigns="campaigns"
          :is-loading-campaigns="isLoadingCampaigns"
          :default-campaign-id="props.initialCampaignId"
          :initial-contact="props.initialContact"
          :create-initial-contact-on-campaign-select="props.createInitialContactOnCampaignSelect"
          :single-selection="isSingleContactFlow"
          @update:contacts="handleContactsUpdate"
          @update:campaign="handleCampaignUpdate"
          @load-contacts="handleLoadContacts"
          @manual-dialog-visibility="handleManualDialogVisibility"
        />
      </KeepAlive>

      <KeepAlive :max="1">
        <SelectTemplateStep
          v-if="currentStep === 2"
          :key="`template-${dialogSessionKey}`"
          :templates="availableTemplates"
          :campaign-id="selectedCampaignForFilter?.id"
          :is-loading-templates="isLoadingTemplates"
          :templates-meta="templateService.templatesMeta.value"
          :selected-template="selectedTemplate"
          :custom-fields="selectedContactCustomFields"
          :use-custom-field-parameters="!isSingleContactFlow"
          @update:template="handleTemplateUpdate"
          @update:parameters="handleParametersUpdate"
          @load-templates="loadTemplatesForSelectedCampaign"
        />
      </KeepAlive>

      <KeepAlive :max="1">
        <SelectRoutingDestinationStep
          v-if="currentStep === 3"
          :key="`routing-${dialogSessionKey}`"
          :campaigns="campaignsForRouting"
          :users="users"
          :bots="bots"
          :is-loading-campaigns="isLoadingCampaignsForRouting"
          :is-loading-users="isLoadingUsers"
          :is-loading-bots="isLoadingBots"
          :default-campaign-id="defaultRoutingCampaignId"
          :default-user-id="defaultRoutingUserId"
          @update:destination="handleDestinationUpdate"
          @load-campaigns="handleLoadCampaignsForRouting"
          @load-users="handleLoadUsers"
          @load-bots="handleLoadBots"
        />
      </KeepAlive>

      <PreviewAndSendStep
        v-if="currentStep === 4"
        :contacts="selectedContacts"
        :template="selectedTemplate"
        :parameters="templateParameters"
        :destination="routingDestination"
      />
    </div>

    <div class="mt-4">
      <div class="flex w-full justify-end gap-2 sm:gap-4">
        <AppButtonIcon
          v-if="currentStep > 1"
          :label="$t('general.back')"
          severity="secondary"
          size="small"
          class="w-full whitespace-nowrap md:w-1/4"
          :disabled="isLoading"
          @click="handlePreviousStep"
        >
          <template #icon>
            <ChevronLeft :size="20" />
          </template>
        </AppButtonIcon>

        <!-- Spacer cuando no hay botón izquierdo -->
        <div v-else class="w-4/4" />

        <AppButtonIcon
          v-if="currentStep < totalSteps"
          :label="$t('whatsapp.send_template_dialog.next')"
          severity="primary"
          icon-pos="right"
          size="small"
          class="w-full whitespace-nowrap md:w-1/4"
          :disabled="!canProceedToNextStep"
          @click="handleNextStep"
        >
          <template #icon>
            <ChevronRight :size="20" />
          </template>
        </AppButtonIcon>

        <AppButtonIcon
          v-else
          :label="$t('whatsapp.send_template_dialog.send_template')"
          size="small"
          icon-pos="right"
          class="montserrat w-1/2 whitespace-nowrap sm:w-1/4"
          :loading="isLoading"
          :disabled="!canSendTemplate"
          @click="handleSend"
        >
          <template #icon>
            <SendHorizontal :size="16" />
          </template>
        </AppButtonIcon>
      </div>
    </div>
  </AppDialog>

  <AppDialog
    v-model="showTakeoverConfirm"
    modal
    :closable="false"
    width="clamp(300px, 90vw, 500px)"
  >
    <div class="flex flex-col gap-4 p-2 dark:text-[var(--p-text-color)]">
      <div class="flex items-center gap-2">
        <TriangleAlert :size="22" class="text-amber-500 flex-shrink-0" />
        <span class="montserrat font-semibold text-lg text-[var(--p-primary-color)]">
          {{ $t('whatsapp.takeover.title') }}
        </span>
      </div>

      <p class="text-sm leading-relaxed">
        <template v-if="takeoverCheck?.reserved_by_others">
          {{ $t('whatsapp.takeover.attended_by', { names: attendingUserNames }) }}
          {{ $t('whatsapp.takeover.warning_others') }}
        </template>
        <template v-else>
          {{ $t('whatsapp.takeover.reserved_by_you') }}
          {{ $t('whatsapp.takeover.warning_self') }}
        </template>
      </p>

      <div class="flex justify-end gap-3">
        <AppButtonIcon
          :label="$t('whatsapp.takeover.cancel')"
          severity="secondary"
          size="small"
          class="whitespace-nowrap"
          @click="handleTakeoverCancel"
        >
          <template #icon>
            <X :size="16" />
          </template>
        </AppButtonIcon>
        <AppButtonIcon
          :label="$t('whatsapp.takeover.confirm')"
          size="small"
          icon-pos="right"
          class="montserrat whitespace-nowrap"
          @click="handleTakeoverConfirm"
        >
          <template #icon>
            <SendHorizontal :size="16" />
          </template>
        </AppButtonIcon>
      </div>
    </div>
  </AppDialog>
</template>

<style>
.send-template-dialog.p-dialog {
  max-height: calc(100dvh - 1rem);
}

.send-template-dialog .p-dialog-content {
  overflow-y: auto;
  overscroll-behavior: contain;
}

.send-template-dialog > .p-dialog-header {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 20;
  padding: 0.75rem;
  border: 0;
  background: transparent;
}

.send-template-dialog > .p-dialog-header .p-dialog-header-actions {
  margin-left: 0;
}

@media (max-width: 640px) {
  .send-template-dialog.p-dialog {
    margin: 0.5rem;
    padding-inline: 1rem !important;
  }

  .send-template-dialog.p-dialog .p-dialog-content {
    padding: 1rem;
  }

  .send-template-dialog.p-dialog > .p-dialog-header {
    padding: 0.5rem;
  }

  .send-template-dialog.p-dialog > .p-dialog-footer {
    padding: 0 1rem 1rem;
  }
}
</style>

<script setup lang="ts">
import { ref, computed, watch, KeepAlive } from 'vue'
import { SendHorizontal, ChevronRight, ChevronLeft, X, TriangleAlert } from 'lucide-vue-next'
import SelectCampaignContactsStep from './steps/SelectCampaignContactsStep.vue'
import SelectTemplateStep from './steps/SelectTemplateStep.vue'
import SelectRoutingDestinationStep from './steps/SelectRoutingDestinationStep.vue'
import PreviewAndSendStep from './steps/PreviewAndSendStep.vue'
import { useAuthStore } from '@/stores/useAuthStore'
import { useCampaignService } from '@/services/campaign/useCampaignService'
import { useTemplateService } from '@/components/whatsapp/services/useTemplateService'
import { useBotService } from '@/services/bot/useBotService'
import { useContactService } from '@/services/contact/useContactService'
import IconMessageBulk from '@/assets/svg/message_bulk_icon.svg?component'

import type {
  ContactSelection,
  Template,
  RoutingDestination,
  TemplateSendComponent,
  TemplateSendCheckResponse,
} from '@/components/whatsapp/types/interfaces'
import type { IOptionsCampaign } from '@/services/campaign/interfaces/options-campaign.interface'
import type { BotOption } from '@/services/bot/interfaces'
import { ChatChannel } from '@/services/campaign/enums/chat-channel.enum'
import { TypeCampaign } from '@/services/campaign/enums/type-campaign.enum'
import AppButtonIcon from '@/components/atoms/buttons/AppButtonIcon.vue'
import { useI18n } from 'vue-i18n'
import AppDialog from '@/components/atoms/dialogs/AppDialog.vue'

interface UserOption {
  id: string
  name: string
  email?: string
}

interface Props {
  visible: boolean
  initialContact?: ContactSelection
  initialCampaignId?: string
  incomingRouteId?: string
  chatId?: string
  startConversation?: boolean
  createInitialContactOnCampaignSelect?: boolean
}

const props = defineProps<Props>()
const { t } = useI18n()

const emit = defineEmits<{
  'update:visible': [value: boolean]
  send: [
    data: {
      contacts: ContactSelection[]
      template: Template
      parameters: TemplateSendComponent[] | null
      destination: RoutingDestination
      incoming_route_id?: string
      campaign_id?: string
      chat_id?: string
      is_bulk: boolean
      confirm_takeover?: boolean
    },
  ]
}>()

const isVisible = computed({
  get: () => props.visible,
  set: (value) => emit('update:visible', value),
})

const currentStep = ref(1)
const totalSteps = 4
const isLoading = ref(false)
const dialogSessionKey = ref(0)
const isStepActive = (step: number) => currentStep.value >= step

const selectedContacts = ref<ContactSelection[]>([])
const selectedCampaignForFilter = ref<IOptionsCampaign | null>(null)
const selectedTemplate = ref<Template | null>(null)
const templateParameters = ref<TemplateSendComponent[] | null>(null)
const routingDestination = ref<RoutingDestination | null>(null)

const campaigns = ref<IOptionsCampaign[]>([])
const campaignsForRouting = ref<IOptionsCampaign[]>([])
const users = ref<UserOption[]>([])
const bots = ref<BotOption[]>([])

const takeoverCheck = ref<TemplateSendCheckResponse | null>(null)
const showTakeoverConfirm = ref(false)

const isLoadingCampaigns = ref(false)
const isLoadingTemplates = ref(false)
const isLoadingCampaignsForRouting = ref(false)
const isLoadingUsers = ref(false)
const isLoadingBots = ref(false)
const isManualContactsDialogVisible = ref(false)

const campaignContactsStepRef = ref<InstanceType<typeof SelectCampaignContactsStep> | null>(null)

const authStore = useAuthStore()
const campaignService = useCampaignService()
const templateService = useTemplateService()
const botService = useBotService()
const contactService = useContactService()

const isSimplifiedFlow = computed(() => !!props.initialContact)
const isSingleContactFlow = computed(() => props.startConversation || isSimplifiedFlow.value)

const availableTemplates = computed(() => {
  return templateService.templates.value || []
})

const defaultRoutingCampaignId = computed(() => selectedCampaignForFilter.value?.id ?? null)

const defaultRoutingUserId = computed(() =>
  props.startConversation && authStore.userId ? String(authStore.userId) : null,
)

const selectedContactCustomFields = computed(() => {
  const fieldsById = new Map<string, NonNullable<ContactSelection['custom_fields']>[number]>()

  const primaryContact = selectedContacts.value[0]
  fieldsById.set('name', {
    id: 'name',
    name: t('whatsapp.send_template_dialog.contact_name'),
    value: primaryContact?.name ?? null,
  })
  fieldsById.set('phone', {
    id: 'phone',
    name: t('whatsapp.send_template_dialog.contact_phone'),
    value: primaryContact?.phone ?? null,
  })

  selectedContacts.value.forEach((contact) => {
    contact.custom_fields?.forEach((field) => {
      if (!field.id || fieldsById.has(field.id)) return
      fieldsById.set(field.id, field)
    })
  })

  return Array.from(fieldsById.values())
})

const areTemplateParametersComplete = computed(() => {
  const requiredParameters = (templateParameters.value || []).flatMap(
    (component) => component.parameters || [],
  )

  if (!requiredParameters.length) return true

  return requiredParameters.every((parameter) => {
    if (parameter.type === 'text') return Boolean(parameter.text?.trim())
    if (parameter.type === 'image') return Boolean(parameter.image?.link?.trim())
    return true
  })
})

const canProceedToNextStep = computed(() => {
  switch (currentStep.value) {
    case 1:
      return selectedContacts.value.length > 0
    case 2:
      return selectedTemplate.value !== null && areTemplateParametersComplete.value
    case 3:
      return routingDestination.value !== null
    default:
      return false
  }
})

const canSendTemplate = computed(() => {
  return (
    selectedContacts.value.length > 0 &&
    selectedTemplate.value !== null &&
    routingDestination.value !== null
  )
})

const handleContactsUpdate = (contacts: ContactSelection[]) => {
  selectedContacts.value = contacts
}

const handleCampaignUpdate = (campaign: IOptionsCampaign | null) => {
  selectedCampaignForFilter.value = campaign
  selectedTemplate.value = null
  templateParameters.value = null
  templateService.templates.value = []
  routingDestination.value =
    props.startConversation && campaign
      ? {
          type: 'campaign',
          campaign_id: campaign.id,
          campaign_name: campaign.name,
        }
      : null
}

const handleTemplateUpdate = (template: Template | null) => {
  selectedTemplate.value = template
}

const handleManualDialogVisibility = (visible: boolean) => {
  isManualContactsDialogVisible.value = visible
}

const handleParametersUpdate = (parameters: TemplateSendComponent[] | null) => {
  templateParameters.value = parameters
}

const handleDestinationUpdate = (destination: RoutingDestination | null) => {
  routingDestination.value = destination
}

const handleLoadContacts = async (campaignId: string) => {
  try {
    const response = await contactService.getContacts({ campaign_id: campaignId })
    // Un contacto registrado desde WhatsApp puede no tener teléfono: se le
    // envía por su BSUID.
    const contactOptions = response.data
      .filter((contact) => contact.phone || contact.bsuid)
      .map((contact) => ({
        id: contact.id,
        phone: contact.phone ?? '',
        bsuid: contact.bsuid ?? null,
        name: contact.name,
        custom_fields: contact.custom_fields || [],
        label: contact.phone ? `${contact.name} (${contact.phone})` : contact.name,
      }))

    campaignContactsStepRef.value?.setAvailableContacts(contactOptions)
  } catch (error) {}
}

const handleLoadCampaignsForRouting = async () => {
  isLoadingCampaignsForRouting.value = true
  try {
    campaignsForRouting.value = await campaignService.getAllCampaigns({
      campaign_type: TypeCampaign.CHAT,
      chat_channel: ChatChannel.WHATSAPP,
    })
    users.value = []
  } catch (error) {
  } finally {
    isLoadingCampaignsForRouting.value = false
  }
}

const handleLoadUsers = async (campaignId: string) => {
  isLoadingUsers.value = true
  try {
    const campaignUsers = await campaignService.getCampaignUsers(campaignId)
    users.value = campaignUsers
  } catch (error) {
    users.value = []
  } finally {
    isLoadingUsers.value = false
  }
}

const handleLoadBots = async () => {
  isLoadingBots.value = true
  try {
    bots.value = await botService.getBotOptions()
  } catch (error) {
  } finally {
    isLoadingBots.value = false
  }
}

const loadTemplatesForSelectedCampaign = async (params?: {
  search?: string | null
  category?: string | null
  page?: number
  size?: number
}) => {
  if (!selectedCampaignForFilter.value) {
    templateService.templates.value = []
    return
  }

  isLoadingTemplates.value = true

  try {
    await templateService.fetchTemplatesByCampaign(selectedCampaignForFilter.value.id, {
      search: params?.search,
      category: params?.category,
      page: params?.page ?? 1,
      size: params?.size ?? 10,
      force: true,
    })
  } catch (error) {
  } finally {
    isLoadingTemplates.value = false
  }
}

const handleNextStep = async () => {
  if (!canProceedToNextStep.value) return

  if (currentStep.value === 1) {
    await loadTemplatesForSelectedCampaign()
  }

  if (isSimplifiedFlow.value && currentStep.value === 2) {
    currentStep.value = 4
  } else if (currentStep.value < 4) {
    currentStep.value++
  }
}

const handlePreviousStep = () => {
  if (isSimplifiedFlow.value && currentStep.value === 4) {
    currentStep.value = 2
  } else if (currentStep.value > 1) {
    currentStep.value--
  }
}

const attendingUserNames = computed(() =>
  (takeoverCheck.value?.attending_users || []).map((user) => user.name || user.id).join(', '),
)

const destinationPointsToMe = computed(() => {
  const destination = routingDestination.value
  return (
    destination?.type === 'user' &&
    String(destination.user_id || '') === String(authStore.userId || '')
  )
})

// El chat del destino está reservado y este envío cambiaría su atención:
// por otros agentes (takeover) o porque el remitente dejaría de atenderlo (handoff)
const requiresTakeoverConfirmation = (check: TemplateSendCheckResponse): boolean => {
  if (!check.reserved) return false
  if (check.reserved_by_others) return true
  return check.reserved_by_me && !destinationPointsToMe.value
}

const checkSendReservation = async (): Promise<TemplateSendCheckResponse | null> => {
  const contact = selectedContacts.value[0]
  const template = selectedTemplate.value
  if (!contact || !template) return null

  return templateService.checkTemplateSendReservation({
    phone: contact.phone,
    bsuid: contact.bsuid ?? undefined,
    template_id: template.id,
    user_id: String(authStore.userId || ''),
    account_id: template.account_id,
  })
}

const handleSend = async () => {
  if (!canSendTemplate.value) return

  isLoading.value = true

  try {
    if (isSingleContactFlow.value) {
      const check = await checkSendReservation()
      if (check && requiresTakeoverConfirmation(check)) {
        takeoverCheck.value = check
        showTakeoverConfirm.value = true
        return // no enviar aún: el usuario decide en el diálogo de confirmación
      }
    }

    emitSend(false)
  } catch (error) {
  } finally {
    isLoading.value = false
  }
}

const emitSend = (confirmTakeover: boolean) => {
  emit('send', {
    contacts: selectedContacts.value,
    template: selectedTemplate.value!,
    parameters: templateParameters.value,
    destination: routingDestination.value!,
    incoming_route_id: props.incomingRouteId,
    campaign_id: selectedCampaignForFilter.value?.id,
    is_bulk: !isSingleContactFlow.value,
    ...(props.chatId && { chat_id: props.chatId }),
    confirm_takeover: confirmTakeover,
  })
  handleClose()
}

const handleTakeoverCancel = () => {
  showTakeoverConfirm.value = false
  takeoverCheck.value = null
}

const handleTakeoverConfirm = () => {
  showTakeoverConfirm.value = false
  emitSend(true)
  takeoverCheck.value = null
}

const handleClose = () => {
  if (isLoading.value) return

  currentStep.value = 1
  dialogSessionKey.value += 1
  isManualContactsDialogVisible.value = false
  selectedContacts.value = []
  selectedCampaignForFilter.value = null
  selectedTemplate.value = null
  templateParameters.value = null
  routingDestination.value = null
  campaignsForRouting.value = []
  users.value = []
  bots.value = []

  emit('update:visible', false)
}

const loadInitialData = async () => {
  isLoadingCampaigns.value = true

  try {
    campaigns.value = await campaignService.getAllCampaigns()
  } catch (error) {
  } finally {
    isLoadingCampaigns.value = false
  }
}

watch(
  () => props.visible,
  async (visible) => {
    if (visible) {
      await loadInitialData()

      if (props.initialContact && !props.createInitialContactOnCampaignSelect) {
        selectedContacts.value = [props.initialContact]
        currentStep.value = 2
      } else if (props.initialContact) {
        currentStep.value = 1
      }

      if (props.initialCampaignId) {
        const campaign = campaigns.value.find((c) => c.id === props.initialCampaignId)
        if (campaign) {
          selectedCampaignForFilter.value = campaign

          routingDestination.value = {
            type: 'campaign',
            campaign_id: campaign.id,
            campaign_name: campaign.name,
          }
        }
      }

      if (isSimplifiedFlow.value && selectedCampaignForFilter.value) {
        await loadTemplatesForSelectedCampaign()
      }
    } else {
      handleClose()
    }
  },
)
</script>
